module.exports = __webpack_public_path__ + "static/img/liucheng6@2x.739a920b.png";